import {createFeature, createReducer, on} from "@ngrx/store";
import * as AuthActions from "../actions/auth.actions";

const authFeatureKey = "Auth";

export interface State {
  isLoggedIn: boolean;
  isUser: boolean | null;
  isAdmin: boolean | null;
  userRoles: Array<string> | null;
  token: string | null;
}

export const initialState: State = {
  isLoggedIn: false,
  isUser: null,
  isAdmin: null,
  userRoles: null,
  token: null
};

export const authFeature = createFeature({
  name: authFeatureKey,
  reducer: createReducer(
    initialState,
    on(AuthActions.setIsLoggedIn, (state: State, {isLoggedIn}): State => ({...state, isLoggedIn: isLoggedIn})),
    on(AuthActions.setUserRoles, (state: State, {userRoles}): State => ({...state, userRoles: userRoles})),
    on(AuthActions.setIsAdmin, (state: State, {isAdmin}): State => ({...state, isAdmin: isAdmin, isLoggedIn: true})),
    on(AuthActions.setIsUser, (state: State, {isUser}): State => ({...state, isUser: isUser, isLoggedIn: true})),
    on(AuthActions.setToken, (state: State, {token}): State => ({...state, token: token}))
  )
});

export const {name, reducer, selectIsLoggedIn, selectUserRoles, selectIsUser, selectIsAdmin, selectToken} = authFeature;
